module.exports = __webpack_public_path__ + "img/sliderMove.8c234415.svg";